import { Box } from "@jewlr/storybook/core"
import styled from "styled-components"

export const Tag = styled(Box).attrs((props) => ({
  bg: props.bg || props.theme.colors.black,
  fontSize: "11px",
  lineHeight: "21px",
  p: "0 8px",
  ...props,
}))`
  color: ${(props) => props.theme.colors.white};
  display: inline-block;
  position: relative;
  bottom: 8px;
  min-width: 21px;
  &:empty {
    background-color: transparent !important ;
  }
  :before,
  :after {
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    display: block;
    content: " ";
    border: 5px solid transparent;
    width: 0;
    height: 0;
    bottom: -15px;
    border-top-color: ${(props) => props.bg || props.theme.colors.white};
  }
`
export const StoneTable = styled(Box).attrs((props) => ({
  as: "table",
  m: "0 auto 24px",
  maxWidth: "250px",
  width: { _: "75%", desktop: "55%" },
  ...props,
}))`
  text-align: left;
  td {
    font-weight: 700;
  }
  span {
    font-weight: 500;
  }
`
